import React from 'react';
import { HiOutlineUser } from 'react-icons/hi';

/**
 * Profile chip at the foot of the sidebar.
 *
 * There is no login in this channel: every visitor is a guest, so this is
 * presentational only and deliberately has no menu or sign-in affordance.
 */
export default function UserProfile({ collapsed }) {
  return (
    <div
      className={`flex items-center gap-2.5 border-t border-hairline px-3 py-3 ${
        collapsed ? 'justify-center' : ''
      }`}
      title="Guest"
    >
      <span
        className="inline-flex h-7 w-7 flex-none items-center justify-center rounded-full
          bg-elevated text-ink-muted"
        aria-hidden="true"
      >
        <HiOutlineUser size={15} />
      </span>

      {!collapsed && (
        <div className="min-w-0">
          <p className="truncate text-[13px] font-medium text-ink">Guest</p>
          <p className="truncate text-[11px] text-ink-faint">Not signed in</p>
        </div>
      )}
    </div>
  );
}
